import React from "react";
import { connect } from "react-redux";

import { fetchP24LogsByFilter } from "../../../actions/p24LogActions";

import { PageHeader } from "../../../components/PageHeader";
import P24LogFilter from "../../../components/p24/P24LogFilter";
import P24LogTable from "../../../components/p24/P24LogTable";

/**
 * Logi P24
 */
class P24Logs extends React.Component {

    componentDidMount() {

        //ladowanie danych do tabeli
        this.props.fetchP24LogsByFilter(this.props.p24LogFilter);
    }

    onFilterChange = () => {
        //ladowanie danych do tabeli - po aktualizacji filtra
        this.props.fetchP24LogsByFilter(this.props.p24LogFilter);
    }

    render() {

        return (
            <div>
                <PageHeader text="app.p24LogPage.title" />

                <P24LogFilter onFilterChange={this.onFilterChange} />

                <br />

                <P24LogTable logs={this.props.p24LogList} />

            </div>
        )
    }
}

const mapStateToProps = state => ({
    p24LogFilter: state.p24LogReducer.p24LogFilter,
    p24LogList: state.p24LogReducer.p24LogList
});

const mapDispatchToProps = ({
    fetchP24LogsByFilter: fetchP24LogsByFilter
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P24Logs);